import { create } from "zustand";
import { devtools } from "zustand/middleware";

import { Label } from "../providers/label-provider";

interface LabelStoreState {
  selectedLabel?: Label;
  setSelectedLabel: (label?: Label) => void;
  labelFormOpen: boolean;
  setLabelFormOpen: (open: boolean) => void;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
}

export const useLabelStore = create<LabelStoreState>()(
  devtools((set) => ({
    selectedLabel: undefined,
    setSelectedLabel: (label) => set({ selectedLabel: label }),
    labelFormOpen: false,
    setLabelFormOpen: (open) => set({ labelFormOpen: open }),
    isLoading: false,
    setIsLoading: (isLoading) => set({ isLoading }),
  })),
);
